/**
 * A compact risk note for the Get EA page.
 *
 * This is the page where a visitor commits to running GoldWarden on a live
 * account, so it should state plainly that "free" does not mean "risk-free",
 * matching the tone used on the How It Works and Performance pages. It carries
 * no link — the Claim section directly above already holds the main CTA, so a
 * second link to the same action would just repeat it.
 */
export default function RiskNote() {
  return (
    <section className="py-10 md:py-12 bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
            <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
              <i className="ri-error-warning-line text-xl" aria-hidden="true"></i>
            </span>
            <p className="flex-1 text-xs md:text-sm leading-relaxed text-foreground-600">
              <strong className="font-semibold text-foreground-900">Free is not the same as risk-free.</strong>{' '}
              GoldWarden costs nothing to run, but trading gold always carries real risk. It manages that risk
              by fixed rules — it cannot remove it. A losing run is always possible, so start small and only
              trade money you can afford to lose.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}